/**
 * Video / Image element (assets/views/elements/video.twig).
 *
 * Clicking the play button replaces the poster with an autoplaying player in
 * place — there is no lightbox in the design. The listener is delegated on the
 * document so it survives Salient's ajax page transitions, which swap
 * #ajax-content-wrap out from under any element-bound handler.
 *
 * de-kaper's version of this is a jQuery plugin. Plain JS here because this is
 * the theme's only front-end script and jQuery would be its only dependency;
 * the admin picker (assets/js/admin/attach-video.js) stays on jQuery, since
 * wp.media requires it.
 *
 * The player is built with DOM APIs rather than an HTML string so the URLs are
 * never parsed as markup.
 */
(function () {
  'use strict';

  function buildEmbed(src) {
    const iframe = document.createElement('iframe');

    // Both providers take autoplay as a query parameter, and getVideoUrl()
    // hands over a bare embed URL, so the separator is only ever a '?'.
    iframe.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
    iframe.allow = 'autoplay; fullscreen; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.setAttribute('frameborder', '0');

    return iframe;
  }

  function buildFile(src) {
    const video = document.createElement('video');

    video.src = src;
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;

    return video;
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.js-video-play');

    if (!button) {
      return;
    }

    const frame = button.closest('.js-video');

    if (!frame) {
      return;
    }

    const isEmbed = frame.dataset.videoType === 'embed';
    const src = isEmbed ? frame.dataset.videoEmbed : frame.dataset.videoSrc;

    if (!src) {
      return;
    }

    frame.replaceChildren(isEmbed ? buildEmbed(src) : buildFile(src));
  });
})();
